import React, { Component } from "react";
import LandingPageThreeSteps from "./template/LandingPageThreeSteps";
import LandingPageHowToProfit from "./template/LandingPageHowToProfit";
import LandingPageDiveIntoMiles from "./template/LandingPageDiveIntoMiles";
import LandingPageCollapses from "./template/LandingPageCollapses";
import LandingPageHowMuch from "./template/LandingPageHowMuch";
import LandingPageLayoutFooter from "./layout/LandingPageLayoutFooter";
import LandingPageAverageMiles from "./template/LandingPageAverageMiles";
import LandingPageQuiz from "./template/LandingPageQuiz";

import { withGetScreen } from "react-getscreen";

import { logoMMWhite } from "../../../img/mm-logo-branca.png";

class LandingPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			submitted: false
		};
	}

	submitted = () => {
		this.setState({
			submitted: true
		});
	};

	render() {
		return (
			<div>
				<LandingPageQuiz submitted={() => this.submitted()} />
				<LandingPageThreeSteps />
				<LandingPageHowToProfit />
				<LandingPageDiveIntoMiles didSubmitted={this.state.submitted} submitted={() => this.submitted()} />
				<LandingPageCollapses />
				{!this.state.submitted && <LandingPageHowMuch submitted={() => this.submitted()} />}
				{this.state.submitted && <LandingPageAverageMiles />}
				<LandingPageLayoutFooter />

				{/* Header image */}
				<div className="offers-landing-page-header">

				</div>
			</div>
		);
	}
}

export default withGetScreen(LandingPage, {
	mobileLimit: 468, // TODO Fix screen vars
	tabletLimit: 768, // TODO Fix screen vars
	shouldListenOnResize: true
});
